const DASH = {
  SET_DASH_STATS_QUERY: 'SET_DASH_STATS_QUERY',
};

export default DASH;
